export default __webpack_public_path__ + "static/media/total-users.a29a5468.png";